<template>
  <v-app id="product">
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      color="#007bff"
      :height="45"
      :width="75"
      :is-full-page="fullPage"
    ></loading>
    <v-container>
   
      <v-row id="product__rowpadding" v-if="muid !== undefined || product_id != undefined">
        <v-col
:cols="4"
          class="label-field text-left no-right no-bottom bold-text"><span>Product Id </span>
         
          :
          </v-col
        >
        <v-col :cols="6" class="label-field text-left no-left no-bottom">{{
          current_pdf_product_id
        }}</v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="last_worked_user !== ''">
        <v-col :cols="4" class="label-field  bold-text text-left no-right no-bottom"
          >Last Worked User:
        </v-col>
        <v-col :cols="6" class="label-field text-left no-left no-bottom">{{
          last_worked_user
        }}</v-col>
      </v-row>     
      <v-row id="product__rowpadding">
        <v-col
          :cols="4"
          class="label-field text-left bold-text no-right no-bottom"
        >Panelists :</v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <div class="flex">
            <div id="product__panelists">
              <ul id="product__panelists--list">
                <li
                  v-for="(p, i) in panelists"
                  v-bind:key="i"
                  v-ripple="{ class: `primary--text` }"
                >
                  <div id="product__panelists--list__left">
                    {{ panelistStrFormat(p) }}
                  </div>
                  
                </li>
              </ul>
            </div>
           
          </div>
         
        </v-col>
      </v-row>
     
      
       <!-- Product PDF -->
       
      
          <v-row id="product__rowpadding"  align="center" v-if="isAddProduct == true">
            <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
              >Product PDF :
            </v-col>
            
            <v-col :cols="6" class=" text-left no-left no-bottom no-top">
              
                 <div v-if = "current_pdf_filename !== ''">
               Current PDF : <a href= "#" @click="open_product_pdf(current_pdf_product_id)" style="text-decoration: none;" >{{current_pdf_filename}}</a>
                / <a href= "#" @click="manage_pdf(current_pdf_product_id)" style="text-decoration: none;" >Manage Preview</a>
             </div>
             
            </v-col>
             
          </v-row>
      
      <!-- End here-->
       

      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left bold-text no-right no-bottom"
          >Company :</v-col
        >
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
         
         
          <div id="product__addcompany" v-if="companies.length > 0">
            <ul id="product__addcompany--list">
              <li v-for="(c, i) in companies" v-bind:key="i">
                {{ c.companyName }}
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>

      
      
      
      <v-row id="product__rowpadding" v-if="affinity != ''">
        <v-col :cols="4" class="label-field  bold-text text-left no-right no-bottom"
          >Affinity/Association :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
         
          <ul id="affinity_association">
            <li v-for="(a, i) in affinity" v-bind:key="i" style="padding: 5px">
              {{
                a.affinityName +
                (a.AffinityCategoryName === null
                  ? ""
                  : " (" + a.AffinityCategoryName + ") ")
              }}
             
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left bold-text  no-right no-bottom"
          >Media Channel:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{media_channel}}
        </v-col>
      </v-row>
     
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field bold-text  text-left no-right no-bottom"
          >Audience:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{audience}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field bold-text text-left no-right no-bottom"
          >Sector/Category/Sub Category :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <div id="product__addcompany" v-if="sectorsData.length > 0">
            <ul id="product__addcompany--list">
              <li v-for="(c, i) in sectorsData" v-bind:key="i">
                <span v-for="(el, index) in c" v-bind:key="index">
                  <strong v-if="index == 0">{{ el.name }}</strong>
                  <strong v-else>/ {{ el.name }}</strong>
                </span>
               
              </li>
            </ul>
          </div>
          
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.issue_type">
        <v-col :cols="4" class="label-field bold-text  text-left no-right no-bottom"
          >Issue Type :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{issueType}}
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="offer_origin != ''"
      >
        <v-col :cols="4" class="label-field bold-text text-left no-right no-bottom"
          >Offer Origin :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{offer_origin}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field bold-text text-left no-right no-bottom"
          >Product Name :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          
         {{product_name}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Product Headline:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{product_headline}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="media_channel === 5">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Observed Traffic Source :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{observed_traffic_source}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Worksite/Voluntary :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="worksite_voluntary == 1">Yes</span>
        <span v-else>No</span>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.perscription">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Rx :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="perscription == 1">Yes</span>
        <span v-else>No</span>
        
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.is_hphsa">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >CDHP/HDHP/HSA	 :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="is_hphsa == 1">Yes</span>
        <span v-else>No</span>
         
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Pre-Screen & Opt-Out Notice :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
         <span v-if="isPreScreen == 1">Yes</span>
        <span v-else>No</span>
          
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.fee_product">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Fee Product :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="fee_product == 1">Yes</span>
        <span v-else>No</span>
         
        </v-col>
      </v-row>


      <v-row id="product__rowpadding" v-if="toggle_sector_divs.tip_on_card">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Tip on Card :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <span v-if="tip_on_card == 1">Yes</span>
          <span v-else>No</span>
        </v-col>
      </v-row>

      <v-row id="product__rowpadding" v-if="toggle_sector_divs.handwriting">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Handwriting :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <span v-if="handwriting == 1">Yes</span>
          <span v-else>No</span>
        </v-col>
      </v-row>

      <v-row id="product__rowpadding" v-if="toggle_sector_divs.faux_check">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Faux Check :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <span v-if="faux_check == 1">Yes</span>
        <span v-else>No</span>
         
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="ancillaryProducts != ''"
      >
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Ancillary Products :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{ancillaryProducts}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.group_size">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Group Size :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{groupSize}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.face_amount">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Face Amount :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{faceAmount}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.term_length">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Term Length :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{termLength}}
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="media_channel === 1 || media_channel === 2"
      >
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >DM/TM Source :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{dm_tm_source}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="media_channel === 2">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Publication :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
         
         
          <ul id="affinity_association">
            <li v-for="(p, i) in publications" v-bind:key="i">
              {{ p.publication_name }} [{{ p.publication_date }}]
              
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="response_mechanism != ''">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Response Mechanism :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        
         {{response_mechanism}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Business Content :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        
        {{business_content}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Personalization :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="personalization == 1"> Yes </span>
        <span v-else> No </span>
       
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Mailing Type:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{mailing_type}}
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.riders">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Riders :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
         {{riders}}
        </v-col>
      </v-row>
      <Delivery v-bind:showDelivery="toggle_sector_divs.delivery" />
      <v-row id="product__rowpadding" v-if="sectorsData.length > 0">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Communication Type:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
         {{communication_type}}
        </v-col>
      </v-row>
      
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Campaign Language :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        
        
        {{campaign_language}}
         
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if= "target_market != ''">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Target Market :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{target_market}}
         
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >State Province:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{state_province}}
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="
          media_channel === 5 ||
          media_channel === 2 ||
          media_channel === 6 ||
          media_channel === 14
        "
      >
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Primary Country :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{primary_country}}
         
        </v-col>
      </v-row>
      
      <div >
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="bold-textlabel-field text-left no-right no-bottom"
            >Gender :
          </v-col>
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{gender}}
            
          </v-col>
        </v-row>
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Age</v-col
          >
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{product_age}}
           
          </v-col>
        </v-row>
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Income</v-col
          >
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{product_income}}
           
          </v-col>
        </v-row>
      </div>
      <Banking v-bind:showBanking="toggle_sector_divs.banking" />
      <CreditCard v-bind:showCreditCard="toggle_sector_divs.creditCard" />
      <MortgageLoans
        v-bind:showMortgageLoans="toggle_sector_divs.MortgageLoans"
      />
      <Telecom v-bind:showTelecom="toggle_sector_divs.telecom" />
      <TravelLeisure
        v-bind:showTravelLeisure="toggle_sector_divs.travelLeisure"
      />
      <PaymentCard v-bind:showPaymentCard="toggle_sector_divs.paymentCard" />
      <Energy v-bind:showEnergy="toggle_sector_divs.energy" />
      <Retail v-bind:showRetail="toggle_sector_divs.retail" />
      <Advertiser v-bind:advertiserSectorsSet="toggle_sector_divs.advertiserSectorsSet" />
      <Promotion v-bind:promotionSectorsSet="toggle_sector_divs.promotionSectorsSet" />
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >CITI :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="citi == 0"> NO </span>
        <span v-else> yes </span>
        </v-col>
      </v-row>
       <v-row id="product__rowpadding"  v-if="isAddProduct == true">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Comment:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          {{product_comment}}
        </v-col>
      </v-row>

       <v-row id="product__rowpadding"  v-if="isAddProduct == true">
        <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom"
          >Product Status:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <span v-if="product_status == 1"> Approved </span>
        <span v-if="product_status == 2"> UnApproved </span>
        <span v-if="product_status == 4"> Problem </span>
        <span v-if="product_status == 10"> Junk </span>
        <span v-if="product_status == 11"> Temp Product </span>
        <span v-if="product_status == -1"> Unused</span>

        </v-col>
      </v-row>
     
        
    
    </v-container>
    <template>
  <v-row justify="center">
    <v-dialog
      v-model="pdftextdialog"
      width="600px"
    >
      
      <v-card>
        <v-card-title>
          <span class="text-h5">PDF Text</span>
        </v-card-title>
        <v-card-text>
         {{pdf_content}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="pdftextdialog = false"
          >
            Close
          </v-btn>
         
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
  </v-app>
  
</template>

<script>
import _ from "lodash";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";



import Banking from "./../components/product/ViewBanking";
import CreditCard from "./../components/product/ViewCreditCard";
import MortgageLoans from "./../components/product/ViewMortgageLoans";
import Retail from "./../components/product/ViewRetail";
import Telecom from "./../components/product/ViewTelecom";
import TravelLeisure from "./../components/product/ViewTravelLeisure";
import PaymentCard from "./../components/product/ViewPaymentCard";
import Energy from "./../components/product/ViewEnergy";
import Delivery from "./../components/product/Delivery";
import Advertiser from "./../components/product/ViewAdvertiser";
import Promotion from "./../components/product/ViewPromotion";

// import EditPublication from './../components/product/EditPublication'
import { mapGetters } from "vuex";
import moment from "moment";
import { vueTopprogress } from 'vue-top-progress'
import axios from 'axios';
export default {
  name: "Product",
  data: () => ({
    pdftextdialog:false,
    showpdfcontent:false,
    confirm_submit: false,
    after_submit: false,
    content_type:'',
    after_submit_msg: "",
    confirm_submit_text: "",
    editpan_index: "",
    muid: "",
    product_names:[],
    email_subject: "",
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    openPanelist: false,
    showeditpanelist: false,
    openAddCompany: false,
    openAffinityAssociation: false,
    panelistdata: {
      date: "",
      invitationId: "",
      last4digits: "",
      panelist: "",
    },
    watchsectors: "",
    watchcategory: "",
    watchsubcategory: "",
    watchsubsubcategory: "",
    watch_audience: "",
    editSectorMode: false,
    editSectorCombinationIndex: "",
    isLoading: false,
    fullPage: true,
    SectorLabel: "Sector",
    CategoryLabel: "Category",
    SubCategoryLabel: "Sub-Category",
    SubSubCategoryLabel: "Sub Sub Category",
    toggle_sector_divs: {
      paymentCard: false,
      banking: false,
      creditCard: false,
      MortgageLoans: false,
      retail: false,
      telecom: false,
      travelLeisure: false,
      energy: false,
      delivery: false,
      offer_origin: true,
      demographic_info: false,
      ancilarry_products: true,
      group_size: false,
      riders: false,
      face_amount: false,
      term_length: false,
      issue_type: false,
      perscription: false,
      is_hphsa: false,
      fee_product: false,
      faux_check: false,
      tip_on_card: false,
      handwriting: false,
      product_lookup: false,
      advertiserSectorsSet:false,
      promotionSectorsSet:false
    },
    addpublication: false,
    update_type: false,
    searchProductNames: null,
    isAddProduct:null,
    //product pdf constants
    product_pdf:null,
    use_same_process_pdf:false,
    pdf_uploaded:false,
    pdf_filename:null,
    download_link:null,
    tmp_pdf_click:false,
    temppdf_url:null,
    current_pdf_path:'',
    current_pdf_product_id:'',
    current_pdf_filename:''
  }),
  components: {
    vueTopprogress,
    Loading,
    
    
    Banking,
    CreditCard,
    MortgageLoans,
    Retail,
    Telecom,
    TravelLeisure,
    PaymentCard,
    Energy,
    Delivery,
    Advertiser,
    Promotion,
    // EditPublication,
  },
  mounted() {
    // this code has been moved to watch
  },
  computed: {
    ...mapGetters({
      //all_offer_origin: "ProductData/getAllOfferOrigin",
      all_sectors: "ProductData/getAllSectors",
      all_income_type: "ProductData/getAllIncomeType",
      all_age_product: "ProductData/getAllAgeProduct",
      all_primary_country: "ProductData/getAllPrimaryCountry",
      //all_face_amount: "ProductData/getFaceAmount",
      //all_group_size: "ProductData/getAllGroupSize",
      //all_riders: "ProductData/getAllRiders",
      all_ancilary_products: "ProductData/getAllAncilaryProducts",
      all_issue: "ProductData/getAllIssues",
      all_audience: "ProductData/getAudience",
      all_media_chan: "ProductData/getMediaChannel",
      states: "ProductData/getProductStates",
      all_targetmarket: "ProductData/getAllTargetMarket",
      all_campaign_language: "ProductData/getAllCampaignLanguage",
      all_mailing_type: "ProductData/getAllMailingType",
      all_business_content: "ProductData/getAllBusinessContent",
      all_category: "ProductData/getAllCategory",
      all_sub_category: "ProductData/getAllSubCategory",
      all_sub_sub_category: "ProductData/getAllSubSubCategory",
      all_varient_type: "ProductData/getVarientAllType",
      //all_comm_type: 'ProductData/getAllCommType',
      //all_response_type: 'ProductData/getAllResponseType',
      affinity: "ProductData/getAffinity",
      companies: "ProductData/getCompanies",
      panelists: "ProductData/getPanelists",
      sectors: "ProductData/getSector",
      email_status: "Email/getStatus",
      publications: "ProductData/getPublications",
      sectorsData: "ProductData/getSector",
      //communication_types: "ProductData/getCommunicationType",
      img_url: "ProductData/getCurrentCompanyImage",
      last_worked_user: "ProductData/getLastWorkedUser",
      spacy_orgn_companies: 'ProductData/getSecComPred',
      entry_date: 'ProductData/getEntryDate',
      product_comment:'ProductData/getProductComment',
      product_status:'ProductData/getProductStatus',
      current_pdf:'ProductData/getCurrentPdf',
      pdf_content:'ProductData/getPdfContent'

    }),
    product_comment:{
       get: function () {
        return this.$store.getters["ProductData/getProductComment"]
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductComment", o);
      },

    },
    pdf_content:{
       get: function () {
        return this.$store.getters["ProductData/getPdfContent"] == null?"":this.$store.getters["ProductData/getPdfContent"]
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPdfContent", o);
      },


    },
    primary_country: {
      get: function () {
        if(this.$store.getters["ProductData/getPrimaryCountry"].length>0){
         return this.all_primary_country.find(primary_country =>primary_country.value === this.$store.getters["ProductData/getPrimaryCountry"]).text
          
        }else{
          return ""
        }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPrimaryCountry", o);
      },
    },
    all_face_amount: function () {
      let state_all_face_amount = this.$store.getters[
        "ProductData/getAllFaceAmount"
      ];
      let dropdown = this.$utils.checkSectorExistInRawdata(this, state_all_face_amount, 'face_amount')
      return dropdown
    },
    all_term_length: function () {
      let state_all_term_length = this.$store.getters[
        "ProductData/getAllTermLength"
      ];
      let dropdown = this.$utils.checkSectorExistInRawdata(this, state_all_term_length, 'term_length')
      return dropdown
    },
    all_issue_types: function () {
      let state_all_issue_types = this.$store.getters[
        "ProductData/getAllIssueTypes"
      ];
      let dropdown = this.$utils.checkSectorExistInRawdata(this, state_all_issue_types, 'issue_type')
      return dropdown
    },
    all_group_size: function () {
      let state_all_group_size = this.$store.getters[
        "ProductData/getAllRawGroupSize"
      ];
      let dropdown = this.$utils.checkSectorExistInRawdata(this, state_all_group_size, 'group_size')
      return dropdown
    },
    all_riders: function () {
      let state_all_riders = this.$store.getters[
        "ProductData/getAllRawRiders"
      ];
      let dropdown = this.$utils.checkSectorExistInRawdata(this, state_all_riders, 'riders')
      return dropdown
    },
    all_offer_origin: function () {
      //let view = this
      //let pc = view.$productConst
      let state_all_offer_origin = this.$store.getters[
        "ProductData/getAllRawOfferOrigin"
      ];
      let stateSector = this.$store.getters["ProductData/getSector"];
      let all_sectors_selected = [];
      if (stateSector.length == 0) {
        return [];
      } else {
        stateSector.forEach(function (o) {
          o.forEach(function (item) {
            all_sectors_selected.push(item.id.toString());
          });
        });
        //console.log(all_sectors_selected);
        let new_offers = [];
        state_all_offer_origin.forEach(function (e) {
          var common = all_sectors_selected.some(
            (r) => e.oo_sectorID.split(",").indexOf(r) >= 0
          );
          //console.log(common);
          if (common) {
            new_offers.push({ text: e.oo_name, value: e.oo_id });
          }
        });
        //console.log(new_offers);
        return new_offers;
      }
    },
    all_comm_type: function () {
        let state_all_communication_types = this.$store.getters[
                "ProductData/getAllRawCommType"
              ];
        let stateSector = this.$store.getters["ProductData/getSector"];
      let all_sectors_selected = [];
      let selected_audience = [];
      let temp_selected_audience = this.$store.getters["ProductData/getStateAudience"]
      selected_audience.push(temp_selected_audience.toString())
      //console.log(selected_audience);
      if (stateSector.length == 0) {
        return [];
      } else {
        stateSector.forEach(function (o) {
          o.forEach(function (item) {
            all_sectors_selected.push(item.id.toString());
          });
        });   
      } 
       let new_offers = [];
        state_all_communication_types.forEach(function (e) {
          if(e.sector_id != null && e.audience_id != null){
            let common_sectors = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            let common_audience = selected_audience.some(
              (r) => e.audience_id.split(",").indexOf(r) >= 0
            );
            //console.log(e.type,common_sectors,common_audience);
            if (common_sectors && common_audience) {
              new_offers.push({ text: e.type, value: e.ID });
            }
          }
          else if (e.audience_id != null){
            let common_audience = selected_audience.some(
              (r) => e.audience_id.split(",").indexOf(r) >= 0
            );
            if (common_audience) {
              new_offers.push({ text: e.type, value: e.ID });
            }
          }
          else if (e.sector_id != null){
            let common_sectors = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common_sectors) {
              new_offers.push({ text: e.type, value: e.ID });
            }
          }
          else{
            new_offers.push({ text: e.type, value: e.ID });
          }
          
        });
        //console.log(new_offers);
        return new_offers;   
    },
    all_response_type: function () {
      let view = this;
      let pc = view.$productConst;
      let state_all_response_type = this.$store.getters[
        "ProductData/getAllResponseType"
      ];
      if (
        view.$utils.checkIfSectorIndexExist(view, pc.sector.insaurance, 0) ||
        view.$utils.checkIfSectorIndexExist(view, pc.sector.investment, 0)
      ) {
        return state_all_response_type;
      } else {
        let new_responses = state_all_response_type.filter(function (e) {
          return e.value != 1;
        });
        return new_responses;
      }
    },
    fee_product: {
      get: function () {
        return this.$store.getters["ProductData/getFeeProduct"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setFeeProduct", o);
      },
    },
    faux_check: {
      get: function () {
        return this.$store.getters["ProductData/getFauxCheck"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setFauxCheck", o);
      },
    },
    tip_on_card: {
      get: function () {
        return this.$store.getters["ProductData/getTipOnCard"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTipOnCard", o);
      },
    },
    handwriting: {
      get: function () {
        return this.$store.getters["ProductData/getHandwriting"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setHandwriting", o);
      },
    },
    gender: {
      get: function () {
        return this.$store.getters["ProductData/getGender"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setGender", o);
      },
    },
    citi: {
      get: function () {
        return this.$store.getters["ProductData/getCiti"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setCiti", o);
      },
    },
    offer_origin: {
      get: function () {
        
        return this.$store.getters["ProductData/getOfferOrigin"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setOfferOrigin", o);
      },
    },
    state_province: {
      get: function () {
        
          if(this.$store.getters["ProductData/getStateProvince"].length>0){
          const newar = new Array()
          let name_el = ''
          for (let resp in this.$store.getters["ProductData/getStateProvince"]){
            name_el = this.states.find(state_province =>state_province.stateID === this.$store.getters["ProductData/getStateProvince"][resp]).stateName
            newar.push(name_el) 
          }
             return newar.join();

        }else{
          return ""
        }
        
      
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setStateProvince", o);
      },
    },
    ancillaryProducts: {
      get: function () {
        if(this.$store.getters["ProductData/getAncillaryProducts"].length>0){
           const newar = new Array()
           let name_el = ''
           for (let resp in this.$store.getters["ProductData/getAncillaryProducts"]){
               name_el = this.all_ancilary_products.find(ancillaryProducts =>ancillaryProducts.value === this.$store.getters["ProductData/getAncillaryProducts"][resp]).text
               newar.push(name_el)
           }
           return newar.join();
        }
        else{
          return ""

        }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setAncillaryProducts", o);
      },
    },
    groupSize: {
      get: function () {
        return this.$store.getters["ProductData/getGroupSize"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setGroupSize", o);
      },
    },
     faceAmount: {
      get: function () {
        return this.$store.getters["ProductData/getFaceAmount"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setFaceAmount", o);
      },
    },
     termLength: {
      get: function () {
        return this.$store.getters["ProductData/getTermLength"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTermLength", o);
      },
    },
     issueType: {
      get: function () {
        return this.all_issue_types.find(issue_type => issue_type.value === this.$store.getters["ProductData/getIssueType"]).text
        //return this.$store.getters["ProductData/getIssueType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIssueType", o);
      },
    },
    riders: {
      get: function () {
        return this.$store.getters["ProductData/getRiders"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setRiders", o);
      },
    },
    audience: {
      get: function () {
        if(this.$store.getters["ProductData/getStateAudience"]!= ''){
          return this.all_audience.find(audience => audience.value === this.$store.getters["ProductData/getStateAudience"]).text
        }else{
          return ""
        }
        
        //return this.$store.getters["ProductData/getStateAudience"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setAudience", o);
      },
    },
    media_channel: {
      get: function () {
        if(this.$store.getters["ProductData/getStateMediaChannel"] != ""){
          return this.all_media_chan.find(mchannel => mchannel.value === this.$store.getters["ProductData/getStateMediaChannel"]).text
        }else{
          return "NA"

        }
        
        
        //return this.$store.getters["ProductData/getStateMediaChannel"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMediaChannel", o);
        if(o === 3){
          this.$store.dispatch('ProductData/setMediaChannelElectronicType', [1])
        }
      },
    },
    state_specific: {
      get: function () {
        return this.$store.getters["ProductData/getStateSpecific"];
      },
      set: function (o) {
        let view = this
        this.$store.dispatch("ProductData/setStateSpecific", o);
         let state_specific = view.$store.getters["ProductData/getStateSpecific"];
        let selected_states = view.$store.getters["ProductData/getStateProvince"];

        if(state_specific && selected_states.length > 1){
            view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Panelist of different states are not allowed when state specific is checked!",
            });
        }
      },
    },
    offer_expiry_date: {
      set: function (o) {
        this.$store.dispatch("ProductData/setOfferExpiry", o);
      },
      get: function () {
        return this.$store.getters["ProductData/getOfferExpiry"];
      },
    },
    personalization: {
      get: function () {
        return this.$store.getters["ProductData/getPersonalization"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPersonalization", o);
      },
    },
    product_headline: {
      get: function () {
        return this.$store.getters["ProductData/getProductHeadline"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductHeadline", o);
      },
    },
    product_name: {
      get: function () {
        return this.$store.getters["ProductData/getProductName"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductName", o);
      },
    },
    isPreScreen: {
      get: function () {
        return this.$store.getters["ProductData/getIsPrescreen"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIsPrescreen", o);
      },
    },
    worksite_voluntary: {
      get: function () {
        return this.$store.getters["ProductData/getWorksiteVoluntary"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setWorksiteVoluntary", o);
      },
    },
    perscription: {
      get: function () {
        return this.$store.getters["ProductData/getPerscription"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPerscription", o);
      },
    },
    is_hphsa: {
      get: function () {
        return this.$store.getters["ProductData/getIsHphsa"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIsHphsa", o);
      },
    },
    mailing_type: {
      get: function () {
        if(this.$store.getters["ProductData/getMailingType"] === undefined)
          return ""
        else 
          return this.all_mailing_type.find(mailing_type => mailing_type.value === this.$store.getters["ProductData/getMailingType"]).text;
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMailingType", o);
      },
    },
    campaign_language: {
      get: function () {
        if(this.all_campaign_language.length > 0){
          if(this.$store.getters["ProductData/getCampaignLang"] == undefined)
            return this.$store.getters["ProductData/getCampaignLang"]
          else
           return this.all_campaign_language.find(campaign_language =>campaign_language.id).text_value
        }else{
          return ""
        }
         
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setCampaignLang", o);
      },
    },
    communication_type: {
      get: function () {
        if(this.$store.getters["ProductData/getCommunicationType"].length>0){
          const newar = new Array()
          let name_el = ''
          for (let resp in this.$store.getters["ProductData/getCommunicationType"]){
            name_el = this.all_comm_type.find(communication_type =>communication_type.value === this.$store.getters["ProductData/getCommunicationType"][resp]).text
            newar.push(name_el) 
          }
             return newar.join();

        }else{
          return ""
        }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setCommunicationType", o);
      },
    },
    business_content: {
      get: function () {
         if(this.$store.getters["ProductData/getBusinessContent"] != ""){
           return this.all_business_content.find(business_content => business_content.value === this.$store.getters["ProductData/getBusinessContent"]).text
         }else{
            return "No Buisness Content"
         }
         
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setBusinessContent", o);
      },
    },
    response_mechanism: {
      get: function () {
        const respnew = new Array()
        let resp_name = ''
        if(this.$store.getters["ProductData/getResponseMechanism"].length > 0){
          for (let resp in this.$store.getters["ProductData/getResponseMechanism"]){
              resp_name = this.all_response_type.find(response_mechanism => response_mechanism.value === this.$store.getters["ProductData/getResponseMechanism"][resp]).text
              respnew.push(resp_name) 
          }
          return respnew.join();

        }else{
          return ""
        }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setResponseMechanism", o);
      },
    },
    target_market: {
      get: function () {
           if(this.$store.getters["ProductData/getTargetMarket"].length>0){
            const newar = new Array()
            let name_el = ''
            for (let resp in this.$store.getters["ProductData/getTargetMarket"]){
              name_el = this.all_targetmarket.find(target_market =>target_market.value === this.$store.getters["ProductData/getTargetMarket"][resp]).text
              newar.push(name_el) 
            }
              return newar.join();

        }else{
          return ""
        }
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTargetMarket", o);
      },
    },
    varient_entry_id: {
      get: function () {
        return this.$store.getters["ProductData/getVarientEntryId"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setVarientEntryId", o);
      },
    },
    varient_type: {
      get: function () {
        return this.$store.getters["ProductData/getVariantType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setVariantType", o);
      },
    },
    // sector: {
    //     get: function() {
    //         let view = this
    //         let stateSector = this.$store.getters['ProductData/getSector']
    //         if(stateSector != '' && stateSector !== undefined){
    //          this.$utils.setCategory(view,stateSector)
    //         }

    //         return stateSector
    //     },
    //     set: function(o) {
    //         let view = this
    //         this.$store.dispatch('ProductData/setSector', o)
    //         this.$utils.setCategory(view,o)
    //     },
    // },
    // category: {
    //     get: function() {
    //         let view = this
    //         let selectedCategory = this.$store.getters['ProductData/getSelectedCategory']
    //         if(selectedCategory != '' && selectedCategory !== undefined){
    //          this.$utils.setSubCategory(view,selectedCategory)
    //         }

    //         return selectedCategory
    //     },
    //     set: function(o) {
    //         let view = this
    //         this.$store.dispatch('ProductData/setSelectedCategory', o)
    //         this.$utils.setSubCategory(view,o)
    //     },
    // },
    // subCategory: {
    //     get: function() {
    //         let view = this
    //         let selectedSubCategory = this.$store.getters['ProductData/getSelectedSubCategory']
    //         if(selectedSubCategory != '' && selectedSubCategory !== undefined){
    //          this.$utils.setSubSubCategory(view,selectedSubCategory)
    //         }

    //         return selectedSubCategory
    //     },
    //     set: function(o) {
    //         let view = this
    //         this.$store.dispatch('ProductData/setSelectedSubCategory', o)
    //         this.$utils.setSubSubCategory(view,o)
    //     },
    // },
    // subSubCategory: {
    //     get: function() {
    //         return this.$store.getters['ProductData/getSelectedSubSubCategory']
    //     },
    //     set: function(o) {
    //         this.$store.dispatch('ProductData/getSelectedSubSubCategory', o)
    //     },
    // },
    product_age: {
      get: function () {
         if(this.$store.getters["ProductData/getProductAge"].length>0){
           const newar = new Array()
           let name_el = ''
           for (let resp in this.$store.getters["ProductData/getProductAge"]){
             name_el = this.all_age_product.find(product_age =>product_age.value === this.$store.getters["ProductData/getProductAge"][resp]).text
              newar.push(name_el)  
           }
           return newar.join();
         }else{
           return ""
         }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductAge", o);
      },
    },
    product_income: {
      get: function () {
        if(this.$store.getters["ProductData/getProductIncome"].length>0){
          const newar = new Array()
          let name_el = ''
          for (let resp in this.$store.getters["ProductData/getProductIncome"]){
            name_el = this.all_income_type.find(product_income =>product_income.value === this.$store.getters["ProductData/getTargetMarket"][resp]).text
            newar.push(name_el) 
          }
           return newar.join();
          
        }else{
          return ""
        }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductIncome", o);
      },
    },
    observed_traffic_source: {
      get: function () {
        return this.$store.getters[
          "ProductData/getProductObservedTrafficSource"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductObservedTrafficSource", o);
      },
    },
    dm_tm_source: {
      get: function () {
        return this.$store.getters["ProductData/getProductDmTmSource"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductDmTmSource", o);
      },
    },
  },
  methods: {
  showPdfText:function(){
    var view = this
    view.pdftextdialog = true

  },
  showpdfcontent_textarea:function(){
    var view = this
    view.showpdfcontent = view.showpdfcontent== true?false:true

  },
  productSuccessSubmit: function(){
      this.after_submit = false
      parent.window.close();
    },

     open_process_pdf(){
      var view = this
      var muid =view.muid
      view.tmp_pdf_click = true
      
      
      window.open(view.$url('RENDER_PDF')+muid, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800");
    },
    open_directmail_pdf(){
      var view = this
      var muid =view.muid
      view.tmp_pdf_click = true
      let url = view.$url('DIRECT_MAIL_PDF_URL')+"?product_id="+muid
      url = url.replace(/%20/g, " ");


      window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800");
    },
    open_product_pdf(product_id){
      var view = this
      let url = view.$url('DIRECT_MAIL_PDF_URL')+"?product_id="+product_id
      url = url.replace(/%20/g, " ");


      window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800");
    },
    manage_pdf(product_id){
      let url = "../managepdf/"+product_id
      url = url.replace(/%20/g, " ");


      window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800");
    },

    open_uploaded_pdf(){
      var view = this
      var muid =view.muid
      view.tmp_pdf_click = true
      
      window.open(view.$url('UPLOAD_PRODUCT_PDF')+"?product_id="+muid, "_blank");
    },

       approved:function(){
         var view = this
       
       if(view.product_pdf == null && view.use_same_process_pdf == false){
         view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please Upload Product Pdf",
        });
        

       }else{
         this.$store.dispatch('ProductData/setProductStatus',1)
         this.send()
       }
       
    },
    unapproved:function(){
      var view = this
       
      
       if(view.product_pdf == null && view.use_same_process_pdf == false){
         view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please Upload Product Pdf",
        });
        

       }else{
         view.$store.dispatch('ProductData/setProductStatus',2)
         this.send()
       }
       
    },
     problem:function(){
       var view = this
       
      if(view.product_pdf == null && view.use_same_process_pdf == false){
         view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please Upload Product Pdf",
        });
        
        
       }else{
         view.$store.dispatch('ProductData/setProductStatus',4)
         this.send()

       }
    },
    unused:function(){
      var view = this
       
       if(this.product_comment == ''){
          view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please Enter Comment",
        });
        
       }else{
         this.$store.dispatch('ProductData/setProductStatus',-1)
         this.send()

       }
    },
    chooseProductName: function(o) {
          var view = this
          view.$store.dispatch("ProductData/setProductName", o);
          view.searchProductNames = '';
          view.product_names = [];
      },
    getSectorBasedDropdown(stateSector, raw_data, dropdown_type){
      let all_sectors_selected = [];
      if (stateSector.length == 0) {
        return [];
      } else {
        stateSector.forEach(function (o) {
          o.forEach(function (item) {
            all_sectors_selected.push(item.id.toString());
          });
        });
        //console.log(all_sectors_selected);
        let new_dropdown = [];
        raw_data.forEach(function (e) {
            if(dropdown_type == 'face_amount'){
              let common = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common) {
              new_dropdown.push({ text: e.fa_name, value: e.fa_id });
            }
          }
          if(dropdown_type == 'term_length'){
              let common = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common) {
              new_dropdown.push({ text: e.tl_name, value: e.tl_id });
            }
          }
          if(dropdown_type == 'issue_type'){
              let common = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common) {
              new_dropdown.push({ text: e.IssueTypeName, value: e.IssueTypeID });
            }
          }
         console.log(new_dropdown);
          
        });
        return new_dropdown;
      }
    },
    toggleDemoGraphicInfo() {
      this.toggle_sector_divs.demographic_info = !this.toggle_sector_divs
        .demographic_info;
    },
    toggleAddPanelist() {
      this.showeditpanelist = false;
      this.openPanelist = !this.openPanelist;
    },
    clearOfferDate() {
      this.$store.dispatch("ProductData/setOfferExpiry", null);
    },
    chooseAffinity: function (o) {
      let stateAffinity = this.$store.getters["ProductData/getAffinity"];
      let dup = stateAffinity.filter((c) => o.affinityID === c.affinityID);
      if (parseInt(dup.length) === parseInt(0)) {
        stateAffinity.push(o);
      }
      this.$store.dispatch("ProductData/setAffinity", stateAffinity);
      this.openAffinityAssociation = false;
    },
    closeAffinityAssociation: function (e) {
      this.openAffinityAssociation = e;
    },
    manageCompany: function () {
      let route = this.$router.resolve({
        name: "company",
        params: { muid: this.muid },
      });
      window.open(route.href, "_blank");
    },
    // showPdf: function () {
    //   window.open(this.$url('HTML_PDF_SERVICE')+"temppdf/"+this.muid);
    // },
    // showHtml: function () {
    //   window.open(this.$url('HTML_PDF_SERVICE')+"processedhtml/"+this.muid);
    // },
    showHtml: function() {
        var view = this
        window.open(
          view.$url('HTML_PDF_SERVICE')+"processedhtml/"+view.muid,
            'emailhtmlpopup',
            'width=800,height=500'
        )
        window.focus()
    },
    showPdf: function() {
        var view = this
        window.open(
            view.$url('HTML_PDF_SERVICE')+"temppdf/"+view.muid,
            'emailpdfpopup',
            'width=800,height=500'
        )
        window.focus()
    },
    closePanelist: function (e) {
      this.openPanelist = e;
    },
    updateSubmittableSectors: function (payload) {
      let view = this;
      if (Array.isArray(payload) && payload.length) {
        view.$store.dispatch("ProductData/setSectorsDisplayData", payload);
        let sectorsSubmittablePayload = [];
        payload.forEach((item) => {
          let newCombination = [];
          item.forEach((o) => {
            if (o.id) {
              newCombination.push(o.id);
            }
          });
          sectorsSubmittablePayload.push(newCombination);
        });
        view.$store.dispatch(
          "ProductData/setSectorsSubmittable",
          sectorsSubmittablePayload
        );
      } else {
        view.$store.dispatch("ProductData/setSectorsDisplayData", []);
        view.$store.dispatch("ProductData/setSectorsSubmittable", []);
      }
      view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
      view.$utils.checkIfAllPromotionsSectorsExists(view);
       // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance
          if(view.$utils.checkIfAnyCompanyInsExchange(view) && view.$utils.checkIfSectorIndexExist(view, view.$c.category.health_insurance, 1)){
            view.$store.dispatch("ProductData/setOfferOrigin", 4);
          }
        //set worksite volantury
          if(view.$utils.checkIfAnySectorWorksiteVoluntary(view)){
            view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
          }
        //   
    },
    panelistStrFormat: function (o) {
      var str = "";
      if (o.competi_id !== null) {
        // competi_id
        str = str + o.competi_id;
      }
      if (typeof o.invitation_id !== "undefined" && o.invitation_id !== "") {
        // invitation id
        str = str + " [ " + o.invitation_id + " ] ";
      }
      if (typeof o.tracking_id !== "undefined" && o.tracking_id !== "") {
        // last4digits
        str = str + " { " + o.tracking_id + " } ";
      }
      str =
        str +
        " ( " +
        moment(o.pp_date).format("MM/DD/YYYY").toUpperCase() +
        " ) ";

      let state_code = ''
      state_code = this.state_abb(o)
      if(state_code != ''){
        str = str + " / " + state_code;
      }
      return str;
    },
    state_abb: function (p) {
            let state_name = ''
            let raw_states = this.$store.getters["ProductData/getRawProductStates"]
            if(raw_states.length){
                raw_states.forEach((rs) => {
                    if(rs.stateID == p.stateID){
                        state_name = rs.stateCode
                    }
                })
            }
            return state_name

    },
    removePanelist: function (p) {
      this.$store.dispatch("ProductData/removePanelist", p);

      let selected_panelists = this.$store.getters["ProductData/getPanelists"];
      let panelists_have_same_state = []
      let panelists_have_same_age = []
      let panelists_have_same_income = []
      let males = []
      let females = []
      if(selected_panelists.length){
                selected_panelists.forEach((o)=>{
                    // gender
                    if(o.gender != ""){
                        if(o.gender == "M"){
                          males.push(1)
                        }else{
                          females.push(1)
                        }
                    }

                    // state
                    if(o.stateID == p.stateID){
                      panelists_have_same_state.push(1)
                    }
                    // age
                    if(o.age == p.age){
                      panelists_have_same_age.push(1)
                    }
                    // state
                    if(o.incomeID == p.incomeID){
                      panelists_have_same_income.push(1)
                    }
                })

                // set gender accordingly

                if(males.length > 0 && females.length > 0){
                    this.$store.dispatch("ProductData/setGender", '');
                    this.$store.dispatch("ProductData/setGender", "B");
                }else if(males.length > 0){
                    this.$store.dispatch("ProductData/setGender", '');
                    this.$store.dispatch("ProductData/setGender", "M");
                }else if(females.length > 0){
                    this.$store.dispatch("ProductData/setGender", '');
                    this.$store.dispatch("ProductData/setGender", "F");
                }else{
                    this.$store.dispatch("ProductData/setGender", '');
                }

                // set age accordingly
                if(panelists_have_same_age.length == 0){
                    let product_age = this.$store.getters["ProductData/getProductAge"];
                    let new_product_age = product_age.filter((a) => a != p.age);
                    this.$store.dispatch("ProductData/setProductAge", new_product_age);
                }

                // set income accordingly
                if(panelists_have_same_income.length == 0){
                    let product_income = this.$store.getters["ProductData/getProductIncome"];
                    let new_product_income = product_income.filter((i) => i != p.incomeID);
                    this.$store.dispatch("ProductData/setProductIncome", new_product_income);
                }

                // set state accordingly
                if(panelists_have_same_state.length == 0){
                    let product_states = this.$store.getters["ProductData/getStateProvince"];
                    let new_product_states = product_states.filter((s) => s != p.stateID);
                    this.$store.dispatch("ProductData/setStateProvince", new_product_states);
                }

          }else{
            this.$store.dispatch("ProductData/setGender", '');
            this.$store.dispatch("ProductData/setStateProvince", []);
            this.$store.dispatch("ProductData/setProductIncome", []);
            this.$store.dispatch("ProductData/setProductAge", []);
          }

    },
    editPanelist: function (i) {
      this.openPanelist = false;
      if (this.showeditpanelist === false) {
        this.showeditpanelist = true;
        this.editpan_index = i;
      }
    },
    entryDate: function (d) {
      this.$store.dispatch("ProductData/setEntryDate", d);
    },
    offerExpiryDate: function (d) {
      let view = this,
        entryDate = new Date(view.$store.getters['ProductData/getEntryDate']),
        d1 = new Date(d)
      if (entryDate > d1) {
        alert("Offer expiry date shouldn't be older than entry date.")
      }
      view.$store.dispatch("ProductData/setOfferExpiry", d);
    },
    action_sign_on_incentive: function (o) {
      var key = "sign_on_" + o.c;
      this["data"][key][o.key] = o.data;
    },
    closeAddCompany: function (o) {
      this.openAddCompany = o;
    },
    isDisplayedImage: function (i) {
      return this.imgPath(i) !== "" && this.imgPath(i) !== null;
    },
    imgPath: function (i) {
      let d = this.$store.getters["ProductData/getCompanyImageData"],
        arr = [];
      if (Array.isArray(d) && d.length) {
        d.forEach(function (o) {
          if (o.companyID === i.companyID) {
            arr.push(o);
          }
        });
      }
      return arr.length > 0
        ? arr[0].imagePath === null || arr[0].imagePath === ""
          ? ""
          : arr[0].imagePath
        : "";
    },
    showImage: function (c) {
      var view = this;
      view.$store
        .dispatch("ProductData/setCurrentCompanyId", c.companyID)
        .then(function () {
          let path = view.imgPath(c);
          view.$store.dispatch(
            "ProductData/setCurrentCompanyPath",
            path === "" ? "" : view.$c.image_base_url + path
          );
        });
    },
    selectCompany: function (c) {
      let view = this,
        stateCompanies = view.$store.getters["ProductData/getCompanies"],
        dup = stateCompanies.filter((o) => o.companyID === c.companyID);
      view.openAddCompany = false;
      // view.showImage(c);
      if (parseInt(dup.length) === parseInt(0)) {
        stateCompanies.push({
          companyID: c.companyID,
          companyName: c.companyName,
          isWorksiteVoluntary: c.isWorksiteVoluntary,
          isMilitaryCo: c.isMilitaryCo,
          isInsuranceExchange: c.isInsuranceExchange,
          co_states: c.co_states,

        });
      }
      view.$store
        .dispatch("ProductData/setCompanyImageData", {
          companyID: c.companyID,
          imagePath: c.imagePath,
        })
        .then(function () {
          // let path =
          //   c.imagePath === null || c.imagePath === "" ? "" : c.imagePath;
          // view.$store.dispatch(
          //   "ProductData/setCurrentCompanyPath",
          //   path === "" ? "" : view.$c.image_base_url + c.imagePath
          // );
          // view.$store.dispatch("ProductData/setCurrentCompanyId", c.companyID);

             //insert product associative data
          if(c.associatedProductName != null) {
             let all_associated_data = view.$store.getters["ProductData/getCompanyAssociatedData"];
             if(all_associated_data.length){
                all_associated_data.forEach(function(item){
                  if(item.company_id != c.companyID){
                    all_associated_data.push({company_id:c.companyID, product_names : c.associatedProductName.split('##')})
                  }
                })
                view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
                view.$store.dispatch("ProductData/setCompanyAssociatedData", all_associated_data);
             }else{
                all_associated_data.push({company_id:c.companyID, product_names : c.associatedProductName.split('##')})
                view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
                view.$store.dispatch("ProductData/setCompanyAssociatedData", all_associated_data);
             }
          }
          ///////
         
          view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
         //set worksite volantury
          if(view.$utils.checkIfAnyCompanyWorksiteVoluntary(view)){
            view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
          }
      //
      // set military option in target market
       
        if(view.$utils.checkIfAnyCompanyMilitary(view)){
          let stateTargetMarket = view.$store.getters["ProductData/getTargetMarket"];
            if(!stateTargetMarket.includes(13)){
              stateTargetMarket.push(13)
            }
            view.$store.dispatch("ProductData/setTargetMarket", []);
            view.$store.dispatch("ProductData/setTargetMarket", stateTargetMarket);
          }
           // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance
          if(view.$utils.checkIfAnyCompanyInsExchange(view) && view.$utils.checkIfSectorIndexExist(view, view.$c.category.health_insurance, 1)){
            view.$store.dispatch("ProductData/setOfferOrigin", 4);
          }
        });
    },

    traverseCompanies: function (o, order) {
      let view = this
      var companies = this.$store.getters["ProductData/getCompanies"],
        index = _.findIndex(companies, function (i) {
          return i.companyID === o.companyID;
        }),
        toObjOrder =
          order === true
            ? parseInt(index) - parseInt(1)
            : parseInt(index) + parseInt(1),
        thisObj = o,
        thisObjOrder = index,
        toObj = companies[toObjOrder];

      if (
        typeof companies[thisObjOrder] === "undefined" ||
        typeof companies[toObjOrder] === "undefined"
      ) {
        return;
      }
      companies[thisObjOrder] = toObj;
      companies[toObjOrder] = thisObj;
      this.$store.dispatch("ProductData/setCompanies", []);
      this.$store.dispatch("ProductData/setCompanies", companies);
      view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
    },
    removeCompany: function (i) {
      let view = this
      let stateCompanies = this.$store.getters["ProductData/getCompanies"];
      let newCompanies = stateCompanies.filter(
        (o) => o.companyID !== i.companyID
      );
      this.$store.dispatch("ProductData/setCompanies", newCompanies);

      view.$utils.checkIfAllPromotionsCompanyExists(view);

       view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
      //remove product associative data
             let all_associated_data = view.$store.getters["ProductData/getCompanyAssociatedData"];
             if(all_associated_data.length){
                let newCompanyAssociativeData = all_associated_data.filter(
                  (o) => o.company_id !== i.companyID
                );
                view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
                view.$store.dispatch("ProductData/setCompanyAssociatedData", newCompanyAssociativeData);
             }

             if(newCompanies.length == 0){
               view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
             }
          
          //set worksite volantury
          if(view.$utils.checkIfAnyCompanyWorksiteVoluntary(view)){
            view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
          }
          // set military option in target market
       
        if(view.$utils.checkIfAnyCompanyMilitary(view)){
          let stateTargetMarket = view.$store.getters["ProductData/getTargetMarket"];
            if(!stateTargetMarket.includes(13)){
              stateTargetMarket.push(13)
            }
            view.$store.dispatch("ProductData/setTargetMarket", []);
            view.$store.dispatch("ProductData/setTargetMarket", stateTargetMarket);
          }
          // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance
          if(view.$utils.checkIfAnyCompanyInsExchange(view) && view.$utils.checkIfSectorIndexExist(view, view.$c.category.health_insurance, 1)){
            view.$store.dispatch("ProductData/setOfferOrigin", 4);
          }
      //
    },
    removeAffinity: function (i) {
      let stateAffinity = this.$store.getters["ProductData/getAffinity"];
      let newAffinity = stateAffinity.filter((o) => o.affinityID !== i);
      this.$store.dispatch("ProductData/setAffinity", newAffinity);
    },
    submit: function () {
      var view = this,
        validationMsg = view.$utils.validateProduct(view);
       let state_specific = view.$store.getters["ProductData/getStateSpecific"];
        let selected_states = view.$store.getters["ProductData/getStateProvince"];

        if(state_specific && selected_states.length){
            view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Panelist of different states are not allowed when state specific is checked!",
            });
        }
      else if (Array.isArray(validationMsg) && validationMsg.length) {
        view.confirm_submit = true;
        view.confirm_submit_text = validationMsg;
      } else {
        view.send();
      }
    },
    getPdfDetails:function(){
      var view = this
      var endPoint = view.$url("UPLOAD_PRODUCT_PDF")+"?product_id="+view.$store.getters["ProductData/getProductId"]+"&is_file=1"
      view.$fetch({
        url:endPoint,
        type: "GET",
        contentType: "application/json"
      },
      {
        operation: 1,vueScope: view
      }).then(function(r){
        console.log(r.filepath)
      }).catch(function(e){
        console.log(e.responseJSON);
         view.$swal.fire({
           position: "bottom-end",icon: "error",
           title: "something went wrong",
            });
      })
     

    },
    
     uploadPdf:function(){
      var view = this
      let current_active_module = view.$store.getters["RawData/getCurrentActiveModule"]
      let user_id = view.$utils.getCookies('user_id')
      
      // upload product pdf
      let pformdata = view.$utils.filterProductData(view)
      let token =view.$utils.getAccessToken()
      pformdata = JSON.parse(pformdata)
      let formData = new FormData();
      let pdf_content_text = (view.showpdfcontent == true )?pformdata.pdf_content:""
      formData.append('product_pdf', view.product_pdf);
      formData.append('product_id', view.after_submit_msg.product_id);
      formData.append('muid', pformdata.muid);
      formData.append('userid', pformdata.userid);
      formData.append('doucment_created_by', pformdata.userid);
      formData.append('use_same_process_pdf', view.use_same_process_pdf);
      formData.append('pdf_content', pdf_content_text);
      
      var endPoint = view.$url("UPLOAD_PRODUCT_PDF")
     return axios.post(endPoint,
                          formData, {
                              headers: {
                                'moduleid':current_active_module,
                                'userid':user_id,
                                'Authorization': token,
                                'Content-Type': 'multipart/form-data'
                              }
                          }
                          )

    },
     send: function () {
      var view = this;
      view.confirm_submit = false;
      this.isLoading = true;
     
      view
        .$fetch({
          url: view.$url("API") + "addProduct",
          type: "POST",
          data: view.$utils.filterProductData(view),
          contentType: "application/json",
        },{
                operation: 1,
                vueScope: view
            })
        .then(function (r) {
          
          if (r.statusCode === 200) {
             view.after_submit_msg = r.payload;
             console.log("save hitt here")
             
            if (view.product_pdf != null || view.use_same_process_pdf == true){
              
              view.uploadPdf().then(function( ){
                view.isLoading = false; 
               view.$router.push({ name: 'ManagePdf', params: { product_id:view.after_submit_msg.product_id } });
                //view.after_submit = true;
             }).catch(function(){
                view.isLoading = false;
             });
           }else{
             view.isLoading = false;
            view.after_submit_msg = r.payload;
            view.after_submit = true;
           }
           
            
          }
        })
        .catch(function (e) {
          console.log(e.responseJSON);
          view.isLoading = false;
           view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: e.responseJSON.payload.msg,
        });
        });
    },
    cancel: function () {
      var view = this
      let url = (view.content_type == 'direct')?view.$url("DIRECT_MAIL_TEMP_GRIP"):view.$url("TEMP_PRODUCT_LISTING")
      window.location.href = url;
    },
    set_variant_entry_id: function (d) {
      this.$store.dispatch("ProductData/setVarientEntryId", d);
    },
    addSectorCombination: function (mode, i) {
      let view = this;
      if (view.watchsectors == "" || view.watchcategory == "") {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please select Sector and Category!",
        });
        return false;
      }
      //  console.log(view.$utils.checkIfSectorIndexExist(view,view.watchsectors,0),view.$utils.checkIfSectorIndexExist(view,view.watchcategory,1),view.$utils.checkIfSectorIndexExist(view,view.watchsubcategory,2),view.$utils.checkIfSectorIndexExist(view,view.watchsubsubcategory,3));
      if (
        view.$utils.checkIfSectorIndexExist(view, view.watchsectors, 0) &&
        view.$utils.checkIfSectorIndexExist(view, view.watchcategory, 1) &&
        (view.$utils.checkIfSectorIndexExist(view, view.watchsubcategory, 2) ||
          view.watchsubcategory == "") &&
        (view.$utils.checkIfSectorIndexExist(
          view,
          view.watchsubsubcategory,
          3
        ) ||
          view.watchsubsubcategory == "")
      ) {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title:
            "Selected sector/category/subcategory combination already exist!",
        });
        return false;
      }

      let newCombination = [],
        sectorsData = view.$store.getters["ProductData/getSector"];
      //sector
      let sector = view.watchsectors,
        sectorName = view.$utils.getSectorName(view, sector),
        sectorWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(view, sector, 1),
        newSector = {
          id: sector,
          name: sectorName,
          sequence: sectorsData.length + 1,
          sectorWorksiteVoluntary: sectorWorksiteVoluntary,
        };
      newCombination.push(newSector);
      // category
      let category = view.watchcategory,
        categoryName = view.$utils.getCategoryName(view, category),
        categoryWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(view, category, 2),
        newCategory = {
          id: category,
          name: categoryName,
          sequence_no: sectorsData.length + 1,
          sectorWorksiteVoluntary: categoryWorksiteVoluntary
        };
      newCombination.push(newCategory);
      //subcategory
      let subcategory = view.watchsubcategory;
      if (subcategory != "") {
        let subcategoryName = view.$utils.getsubcategoryName(view, subcategory),
        subcategoryWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(view, subcategory, 3),
          newsubcategory = {
            id: subcategory,
            name: subcategoryName,
            sequence_no: sectorsData.length + 1,
            sectorWorksiteVoluntary: subcategoryWorksiteVoluntary
          };
        newCombination.push(newsubcategory);
      }
      //subsubcategory
      let subsubcategory = view.watchsubsubcategory;
      if (subsubcategory != "") {
        let subsubcategoryName = view.$utils.getsubsubcategoryName(
          view,
          subsubcategory
        );
        let subsubcategoryWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(view, subsubcategory, 4);
        let newsubsubcategory = {
          id: subsubcategory,
          name: subsubcategoryName,
          sequence_no: sectorsData.length + 1,
          sectorWorksiteVoluntary: subsubcategoryWorksiteVoluntary
        };
        newCombination.push(newsubsubcategory);
      }
      mode == "add"
        ? sectorsData.push(newCombination)
        : sectorsData.splice(i, 0, newCombination);
      this.updateSubmittableSectors(sectorsData);
      view.watchsectors = "";
      view.watchcategory = "";
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
    },
    removeSectorCombination: function (i) {
      let view = this,
        sectorsData = view.$store.getters["ProductData/getSector"];
      if (sectorsData.length == 1) {
        if (view.editSectorMode === true) {
          sectorsData = [];
          view.updateSubmittableSectors(sectorsData);
        } else {
          view.$swal
            .fire({
              title: "Are you sure ?",
              text:
                "This will clear all Sector/Category/Sub-category dependant fields.",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, remove it !",
              cancelButtonText: "No, cancel !",
              closeOnConfirm: false,
              closeOnCancel: false,
            })
            .then((result) => {
              if (result.isConfirmed) {
                sectorsData = [];
                view.updateSubmittableSectors(sectorsData);
              } else if (result.isDenied) {
                view.$swal.fire(
                  "Cancelled",
                  "Sector/Category/Sub-Category Combination was not removed !",
                  "error"
                );
              }
            });
        }
      } else {
        if (i > -1) {
          sectorsData.splice(i, 1);
          //console.log(i);
        }
        view.updateSubmittableSectors(sectorsData);
      }

      //view.sectorsData = sectorsData
    },
    traverseSectorCombinations: function (i, order) {
      var sectorsData = this.$store.getters["ProductData/getSector"],
        // index = _.findIndex(companies, function(i) {
        //     return i.companyID === o.companyID
        // }),
        toObjOrder =
          order === true
            ? parseInt(i) - parseInt(1)
            : parseInt(i) + parseInt(1),
        thisObj = sectorsData[i],
        thisObjOrder = i,
        toObj = sectorsData[toObjOrder];
      if (
        typeof sectorsData[thisObjOrder] === "undefined" ||
        typeof sectorsData[toObjOrder] === "undefined"
      ) {
        return;
      }
      sectorsData[thisObjOrder] = toObj;
      sectorsData[toObjOrder] = thisObj;

      //this.sectorsData = []
      //this.sectorsData = sectorsData
      this.updateSubmittableSectors(sectorsData);
      // this.$store.dispatch('ProductData/setCompanies', [])
      // this.$store.dispatch('ProductData/setCompanies', companies)
    },
    editSectorCombination: function (i) {
      let view = this;
      view.editSectorCombinationIndex = i;
      view.editSectorMode = true;
      let sectorsData = this.$store.getters["ProductData/getSector"];
      let thisObj = sectorsData[i];
      thisObj.forEach(function (item, index) {
        if (index == 0) {
          view.watchsectors = item.id;
        }
        if (index == 1) {
          view.watchcategory = item.id;
        }
        if (index == 2) {
          view.watchsubcategory = item.id;
        }
        if (index == 3) {
          view.watchsubsubcategory = item.id;
        }
      });
    },
    updateSectorCombination: function (i) {
      let view = this;
      if (view.watchsectors == "" || view.watchcategory == "") {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please select Sector and Category!",
          showConfirmButton: false,
          timer: 2500,
        });
        return false;
      }
      view.removeSectorCombination(i);
      view.addSectorCombination("update", i);
      view.editSectorCombinationIndex = "";
      view.editSectorMode = false;
      view.watchsectors = "";
      view.watchcategory = "";
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
    },
    removePublication: function (i) {
      //let all_publications = this.$store.getters["ProductData/getPublications"];
      // if (i > -1) {
      //   all_publications.splice(i, 1);
      // }
      // let newPublications = all_publications.filter(
      //   (o) => o.companyID !== i.companyID
      // );
      // this.$store.dispatch("ProductData/setCompanies", newCompanies);
      this.$store.dispatch("ProductData/removePublication", i);
    },
    isBonusContentIncentive: function () {
      return this.communication_type.includes(
        this.$c.communication_type.business_content_incentive
      );
    },
    con1: function () {
      return this.$productutils.condition1(this);
    },
    // displayFauxCheck: function() {
    //   let view = this,
    //     sectots = view.$store.getters['ProductData/getSubmittableSectors'],
    //     $c = view.$c.sector,
    //     sec = [$c.investment_annulities, $c.automotive, $c.retail_consumer]
    //   if (sectots.length === 1) {
    //     return !sec.includes(sectots[0][0])
    //   } else if (sectots.length === 2) {
    //     return !(sec.includes(sectots[0][0]) && sec.includes(sectots[1][0]))
    //   } else if (sectots.length === 3) {
    //     return !(sec.includes(sectots[0][0]) && sec.includes(sectots[1][0]) && sec.includes(sectots[2][0]))
    //   } else if (sectots.length === 0) {
    //     return false
    //   }
    //   return true
    // }
  },
  watch: {

    '$store.state.RawData.current_active_module': function(o){
    if(o){
          var view = this;
    
    view.muid = view.$route.params.muid;
    if(view.muid !== undefined){
      this.$refs.topProgress.start()
      
    }
    
    view.$utils.fetchSpaceyData(view);
    let content_type = ''
    if(view.$route.query.ec_content_type === undefined){
      if(view.muid === undefined)
        content_type = "newproduct"
      else
        content_type = ""
      
      
      
    }else if(view.$route.query.ec_content_type !== undefined){
      content_type = view.$route.query.ec_content_type

    }
    //let content_type = view.$route.query.ec_content_type === undefined?"":view.$route.query.ec_content_type
    view.content_type = content_type
    if(view.muid !== undefined){
        view
        .$fetch({
          url: view.$url("EMAIL") + "/" + view.muid,
          type: "GET",
        },{
                  operation: 2,
                  vueScope: view
              })
        .then((response) => {
          // view.$Progress.increase(20)
          if (typeof response.email_subject !== "undefined") {
            view.email_subject = response.email_subject.replace(/\\/g, "");
            if (response.deleted !== "undefined") {
              if (parseInt(response.deleted) === parseInt(1)) {
                view.update_type = true;
              }
            }
          }
          if (typeof response.index_name !== "undefined") {
            view.$store.dispatch("ProductData/setIndexName", response.index_name)
          }
        })
        .catch((e) => console.log(e));

        //company prediction
        view.$utils.sec_company_pred(view)
        view.$store.dispatch("ProductData/setMuid", view.muid);
        // product historical data endpoints
        view.$utils.fetchHistoricalData(view);
        
    }
    

    view.$utils.productRawData(view)
    // view.$utils.sec_pred(view)
    // view.$utils.cat_pred(view)
    // view.$utils.mailing_type_pred(view)
    
    



    
    view.$store.dispatch(
      "ProductData/setUserid",
      view.$utils.getCookies("username").replace(/['"]+/g, "")
    );
     // code added for managing add product route
     this.isAddProduct = (view.$route.name == 'addproduct')?true:false
     //if(this.isAddProduct)
      //view.getPdfDetails()
    }
    },
    '$store.state.ProductData.data.sectors': function(o) {
      if(o){
          this.$utils.sectorRawdataAudienceDependantEndpoints(this);
      }}  
    ,
    current_pdf:function(){
      let view = this
      let splitpath = view.$store.getters['ProductData/getCurrentPdf'].split("/")
      let pdf_filename = splitpath[splitpath.length-1]
      view.current_pdf_filename = pdf_filename
      view.current_pdf_product_id = pdf_filename.split("_")[1].split(".")[0]
    },
    watchelectronic_type: function (o) {
      var view = this;
      o.forEach(function (e) {
        view.data.electronic_type.push(e);
      });
      view.data.electronic_type = _.uniq(view.data.electronic_type);
    },
    watchsectors: function (o) {
      var view = this;
      view.watchsectors = o;
      view.watchcategory = "";
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
      if (o != "") {
        view.$utils.setCategory(view);
      }
    },
    watchcategory: function (o) {
      var view = this;
      view.category = o;
      view.watchsubcategory = "";
      if (o != "") {
        view.$utils.setSubCategory(view);
      }
    },
    watchsubcategory: function (o) {
      var view = this;
      view.subCategory = o;
      if (o != "") {
        view.$utils.setSubSubCategory(view);
      }
    },
    watchsubsubcategory: function (o) {
      this.subsubcategory = o;
    },
    watch_audience: function (o) {
      this.data.audience = o;
    },
    searchProductNames (val) {
        if(!val || val.length == 0){
          this.product_names = []
          return
        }
        let all_associated_data = this.$store.getters["ProductData/getCompanyAssociatedData"];
        
        let filtered_product_names = []
        all_associated_data.map(function(o){
            o.product_names.map(function(name){
              if(name.toLowerCase().match(val.toLowerCase())){
                filtered_product_names.push(name)
              }
            })
        })
        if(filtered_product_names.length == 0){
          filtered_product_names.push('Product Name Not Mentioned')
        }

        this.product_names = filtered_product_names
      },
  },
};
</script>

<style lang="sass" scoped>
@import './../assets/sass/product/product'
.v-card__title
  font-size: 18px!important
</style>